<script lang="ts">
	import type { Card } from '#lib/schema-extension.js';
	import { setAttr } from '@directus/visual-editing';

	let { block }: { block: Card } = $props();
</script>

<div
	data-directus={setAttr({
		collection: 'card',
		item: block.id!!,
		mode: 'modal'
	})}
>
	<div class="bg-base-100 w-full p-4 sm:p-6">
		{#if block.title}
			<h2
				data-directus={setAttr({
					collection: 'card',
					item: block.id!!,
					fields: 'title',
					mode: 'popover'
				})}
			>
				{block.title}
			</h2>
		{/if}
		<div
			class="prose mt-3"
			data-directus={setAttr({
				collection: 'card',
				item: block.id!!,
				fields: 'content',
				mode: 'popover'
			})}
		>
			{@html block.content}
		</div>
	</div>
</div>
